import React from 'react';
import AppRouter from './router'; // Import the router we just created
import './App.css'; // Optional, if you have app-specific styles

function App() {
  return (
    <div>
      <AppRouter />
    </div>
  );
}

export default App;